import { BaseResource } from '/@/modules/core/app/resources/BaseResource';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { Conversation } from '@/modules/messenger/_modules/conversation/models/Conversation';

export class InboxResource extends BaseResource {
  /**
   * @returns {Promise<Conversation>}
   */
  createDefaultConversation() {
    return this.postData(Route.INBOX_DEFAULTCONVERSATION);
  }

  /**
   * @returns {Promise<Conversation>}
   */
  getConversation(conversationId) {
    return this.getData(`${Route.INBOX_CONVERSATIONS}/${conversationId}`, Conversation);
  }

  /**
   * @returns {Promise<Conversation[]>}
   */
  getConversations(userId) {
    return this.getData(Route.INBOX_CONVERSATIONS, Conversation, { userId });
  }

  createConversation(groupName, userIds) {
    return this.postData(Route.INBOX_CONVERSATIONS, {
      group_name: groupName,
      participant_user_ids: userIds
    });
  }

  /**
   * @param {number} userId
   * @param {number} estateId
   * @param {Message} message
   * @returns {Promise<void>}
   */
  sendBotMessage(userId, estateId, message) {
    return this.postData(Route.INBOX_SENDBOTMESSAGE, {
      userId,
      estateId,
      message
    });
  }
  /**
   * @param {string|number} id
   * @param {string|null} groupName
   * @param {Array<number>} participantUserIds
   * @returns {Promise<boolean>}
   */
  updateConversation(id, groupName, participantUserIds) {
    return this.putData(`${Route.INBOX_CONVERSATIONS}/${id}`, {
      groupName,
      participantUserIds
    });
  }

  /**
   * @param {string|number} conversationId
   * @param {Array<number>} participantUserIds
   * @returns {Promise<Conversation>}
   */
  getExistingConversation(conversationId, participantUserIds) {
    return this.getData(Route.INBOX_EXISTINGCONVERSATION, Conversation, {
      conversationId,
      participantUserIds
    });
  }

  /**
   * @returns {Promise<Conversation[]>}
   */
  getUnreadConversations() {
    return this.getData(Route.INBOX_UNREADCONVERSATIONS, Conversation);
  }
}

export default new InboxResource();
